import { render, staticRenderFns } from "./VoucherDetail.vue?vue&type=template&id=903e564e&scoped=true&"
import script from "./VoucherDetail.vue?vue&type=script&lang=js&"
export * from "./VoucherDetail.vue?vue&type=script&lang=js&"
import style0 from "./VoucherDetail.vue?vue&type=style&index=0&id=903e564e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903e564e",
  null
  
)

export default component.exports